import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as Messages } from '@styles/icons/messages.svg';
import React from 'react';

export const MessagesIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={Messages} viewBox={'0 0 18 18'} />
);

export default MessagesIcon;
